module.exports = __webpack_public_path__ + "media/images/outer-highlight-9db51662.svg";